export default __webpack_public_path__ + "static/media/jolt-100-6.63cc7116.jpg";